import script from "./MyBookmarkedCompaniesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBookmarkedCompaniesTab.vue?vue&type=script&setup=true&lang=js"

import "./MyBookmarkedCompaniesTab.vue?vue&type=style&index=0&id=a876abb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a876abb0"]])

export default __exports__